export const DOCUMENT_MODULE_NAMESPACE = 'document';
export const DOCUMENT_GET_DOCUMENTS = 'DOCUMENT_GET_DOCUMENTS';
export const DOCUMENT_DOWNLOAD_DOCUMENTS = 'DOCUMENT_DOWNLOAD_DOCUMENTS';
export const DOCUMENT_SET_DOCUMENTS = 'DOCUMENT_SET_DOCUMENTS';
export const DOCUMENT_GET_DOCUMENTS_SIDEBAR = 'DOCUMENT_GET_DOCUMENTS_SIDEBAR';
export const DOCUMENT_GET_DOCUMENT_TYPES = 'DOCUMENT_GET_DOCUMENTS_TYPE';
export const DOCUMENT_GET_DOCUMENTS_TYPE_LOADING = 'DOCUMENT_GET_DOCUMENTS_TYPE_LOADING';
export const DOCUMENT_GET_DOCUMENTS_SIDEBAR_LOADING = 'DOCUMENT_GET_DOCUMENTS_SIDEBAR_LOADING';
export const DOCUMENT_GET_DOCUMENTS_LOADING = 'DOCUMENT_GET_DOCUMENTS_LOADING';
export const DOCUMENT_RECORD_DOCUMENT = 'DOCUMENT_RECORD_DOCUMENT';
export const DOCUMENT_RECORD_DOCUMENT_LOADING = 'DOCUMENT_RECORD_DOCUMENT_LOADING';
export const DOCUMENT_RESET_DOCUMENT= 'DOCUMENT_RESET_DOCUMENT'
export const DOCUMENT_SET_DOCUMENT= 'DOCUMENT_SET_DOCUMENT'
export const DOCUMENT_SET_ANNOTATION= 'DOCUMENT_SET_ANNOTATION'
export const DOCUMENT_INIT_DOCUMENT= 'DOCUMENT_INIT_DOCUMENT'
export const DOCUMENT_DELETE_DOCUMENT_LOADING = 'DOCUMENT_DELETE_DOCUMENT_LOADING';
export const DOCUMENT_SET_DOCUMENT_PARAMETER= 'DOCUMENT_SET_DOCUMENT_PARAMETER'
export const DOCUMENT_GET_DOCUMENTS_ATTACHMENTS = 'DOCUMENT_GET_DOCUMENTS_ATTACHMENTS'
export const DOCUMENT_SET_DOCUMENTS_PAGINATION = 'DOCUMENT_SET_DOCUMENTS_PAGINATION'
export const DOCUMENT_SET_DOCUMENT_ACTION = 'DOCUMENT_SET_DOCUMENT_ACTION'
export const DOCUMENT_SAVE_DOCUMENT= 'DOCUMENT_SAVE_DOCUMENT'
export const DOCUMENT_EDIT_DOCUMENT= 'DOCUMENT_EDIT_DOCUMENT'
export const EQUIPMENT_EDIT_DOCUMENT = 'EQUIPMENT_EDIT_DOCUMENT'
export const DOCUMENT_UPDATE_DOCUMENT= 'DOCUMENT_UPDATE_DOCUMENT'
export const DOCUMENT_DELETE_DOCUMENT= 'DOCUMENT_DELETE_DOCUMENT'
export const DOCUMENT_REMOVE_DOCUMENT= 'DOCUMENT_REMOVE_DOCUMENT'
export const DOCUMENT_SET_DOCUMENT_SELECTION= 'DOCUMENT_SET_DOCUMENT_SELECTION'
export const DOCUMENT_INIT_DOCUMENT_SELECTION= 'DOCUMENT_INIT_DOCUMENT_SELECTION'
export const DOCUMENT_SET_LOADER_STATE= 'DOCUMENT_SET_LOADER_STATE'
export const DOCUMENT_GET_ATTACHMENT_TYPES = 'DOCUMENT_GET_ATTACHMENT_TYPES'
export const DOCUMENT_GET_DOC_BY_ID = 'DOCUMENT_GET_DOC_BY_ID'
export const DOCUMENT_SEND_TICKET_DOCUMENT= 'DOCUMENT_SEND_TICKET_DOCUMENT'
export const DOCUMENT_LOADERS= Object.freeze({
    FILTERS_LOADER: 'DOCUMENT_FILTER_LOADER',
    TABLE_LOADER: 'DOCUMENT_TABLE_LOADER',
    CATEGORIES_LOADER: 'DOCUMENT_CATEGORIES_LOADER'
})



// WEBPACK FOOTER //
// ./src/store/document/document-types.store.ts